<template>
  <el-select
    v-model="selectedProduct"
    v-bind="$attrs"
    size="mini"
    placeholder="Filtra por producto"
    filterable
    clearable
    @change="handleChange"
  >
    <el-option
      v-for="product in productList"
      :key="product.value"
      :value="product.value"
      :label="product.label"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: "ProductSelector",
  props: {
    product: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedProduct: this.product
    };
  },
  computed: {
    productList() {
      return this.$store.getters["products/getProductSelector"];
    }
  },
  methods: {
    handleChange(val) {
      this.$emit("update:product", val);
      this.$emit("change", val);
    }
  }
};
</script>

<style></style>
